import React, { useState, useEffect } from 'react';
import { FaBuilding, FaPen, FaGripVertical, FaBell, FaUserTag } from 'react-icons/fa';
import api from '../services/api';
import IconButton from '../components/IconButton';
import DropDown from '../components/DropDown';
import Notificacoes from './Notificacoes';
import { getAuthForPath, isParticipantSession } from '../util/authSession';

export default function NavBar() {
    const auth = getAuthForPath();
    const token = auth.token;
    const perfil = auth.perfil;
    // No fluxo do convidado a top bar não tem função útil; deixa ela ABAIXO do loading (Processando,
    // z-index 100) para não aparecer por cima do overlay. Nas telas internas mantém o 102 do CSS
    // (nav/sidebar seguem usáveis durante o load).
    const navStyle = isParticipantSession() ? { zIndex: 99 } : undefined;
    const [empresas, setEmpresas] = useState(JSON.parse(localStorage.getItem("empresas") ?? "[]"));
    // O admin vê as telas como outro cargo: o `perfil` do front vira o escolhido, o dele fica em `perfilReal`, e o back
    // recebe o escolhido em toda chamada (`X-Mock-Perfil`), que vale só para admin. Voltar para admin desfaz.
    const ehAdmin = (localStorage.getItem('perfilReal') ?? perfil) === 'admin';
    const [perfis, setPerfis] = useState([]);
    useEffect(() => {
        if (!ehAdmin || !token) return;
        api({ method: 'get', action: '/rhPerfil', token })
            .then(res => setPerfis(res.data.data ?? []))
            .catch(() => setPerfis([]));
    }, [ehAdmin, token]);
    const simular = (codigo) => {
        if (codigo === 'admin') localStorage.removeItem('perfilReal');
        else localStorage.setItem('perfilReal', 'admin');
        localStorage.setItem('perfil', codigo);
        window.location.reload();
    };
    const [empresaAtual, setEmpresaAtual] = useState({ id: localStorage.getItem("empresa"), nome: localStorage.getItem("nomeEmpresa") });
    const buscar = () => {
        api({
            method: 'get',
            action: '/participante',
            token: token,
            params: {
                ...{
                    orderBy: {
                        nome: "desc"
                    }
                },
                ...{
                    tipoCadastro: "empresa",
                    situacaoRegistro: "ativo"
                }
            }
        })
            .then(response => {
                if (localStorage.getItem("empresa") === null) {
                    localStorage.setItem("empresa", response.data.data[0].id);
                    localStorage.setItem("nomeEmpresa", response.data.data[0].nomefantasia || response.data.data[0].nome);
                    empresaAtual.id = response.data.data[0].id;
                    empresaAtual.nome = response.data.data[0].nomefantasia || response.data.data[0].nome;
                    localStorage.setItem("empresas", JSON.stringify(response.data.data));
                }
                setEmpresas(response.data.data);
            }).catch(err => {
                //console.log(err)
            });
    };

    useEffect(() => { //onload
        if (!token || perfil === 'cliente') {
            return;
        }

        var empresasArray = JSON.parse(localStorage.getItem("empresas") ?? "{}");
        if ((localStorage.getItem("empresa") === null)
            || (empresasArray.length === 0)) {
            buscar();
        }
    },
        // eslint-disable-next-line
        []);

    return (
        <nav className="navbar navbar-header navbar-expand navbar-light no-print" style={navStyle}>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                {/* Logo movido para a sidebar (SideBar.js) */}
                <ul className="navbar-nav d-flex align-items-center navbar-light ms-auto">
                    {!['cliente'].includes(perfil) ? <Notificacoes key={"notificacoes"} /> : null}
                    {ehAdmin && perfis.length > 0 && (
                        <li key="cargo">
                            <DropDown
                                icon={<FaUserTag />}
                                opcoes={perfis.map(p => (
                                    <IconButton key={p.codigo} className="dropdown-item" small={true} color="default"
                                        icon={<FaUserTag size={20} />} onClick={() => simular(p.codigo)}>{p.nome}</IconButton>
                                ))}
                            >{perfis.find(p => p.codigo === perfil)?.nome ?? perfil}</DropDown>
                        </li>
                    )}
                    {!['cliente'].includes(perfil) ?
                        <li key={"empresas"}>
                            <DropDown
                                icon={<FaBuilding />}
                                opcoes={
                                    empresas ? empresas.map((opcao, index) => {
                                        return <IconButton
                                            key={index}
                                            className="dropdown-item"
                                            small={true}
                                            onClick={() => {
                                                localStorage.setItem("nomeEmpresa", opcao.nomefantasia || opcao.nome);
                                                localStorage.setItem("empresa", opcao.id);
                                                setEmpresaAtual({ id: opcao.id, nome: opcao.nomefantasia || opcao.nome });
                                            }}
                                            icon={<FaBuilding size={20} />}
                                            color="default">{opcao.nomefantasia || opcao.nome}</IconButton>
                                    }) : null}
                            >{empresaAtual.nome}</DropDown></li> : null}

                    {/* Menu do usuário (nome + Alterar Senha/Sair) movido para o rodapé da sidebar (SideBar.js) */}
                </ul>
            </div>
        </nav>
    );
}
